import { gql } from "apollo-boost";

export const GET_COURSEOUTLINEASSESSMENT = gql`
  query getCourseOutlineAssessment($id: ID!) {
    getCourseOutlineAssessment(
      id: $id
    ) {
      id seq percent score
      courseOutline{ id }
      assessment{ id nameLocal nameEng }
    }
  }
`;

export const GET_COURSEOUTLINEASSESSMENTS = gql`
  query getCourseOutlineAssessments {
    getCourseOutlineAssessments {
      id seq percent score
      courseOutline{ id }
      assessment{ id nameLocal nameEng }
    }
  }
`;

export const ADD_COURSEOUTLINEASSESSMENT = gql`
  mutation addCourseOutlineAssessment(
    $courseOutlineId: ID,
    $assessmentId: ID,
    $seq: Int,
    $percent: Float,
    $score: Float
  ) {
    addCourseOutlineAssessment (
      courseOutlineId: $courseOutlineId,
      assessmentId: $assessmentId,
      seq: $seq
      percent: $percent
      score: $score
    ) {
      id seq percent score
      courseOutline{ id }
      assessment{ id nameLocal nameEng }
    }
  }
`;

export const UPDATE_COURSEOUTLINEASSESSMENT = gql`
  mutation updateCourseOutlineAssessment(
    $id: ID!,
    $assessmentId: ID,
    $seq: Int,
    $percent: Float,
    $score: Float
  ) {
    updateCourseOutlineAssessment (
      id: $id,
      assessmentId: $assessmentId,
      seq: $seq
      percent: $percent
      score: $score
    ) {
      id seq percent score
      courseOutline{ id }
      assessment{ id nameLocal nameEng }
    }
  }
`;

export const DELETE_COURSEOUTLINEASSESSMENT = gql`
  mutation deleteCourseOutlineAssessment(
    $id: ID!
  ) {
    deleteCourseOutlineAssessment (
      id: $id
    ) {
      id seq percent score
      courseOutline{ id }
      assessment{ id nameLocal nameEng }
    }
  }
`;


/* TYPES

type CourseOutlineAssessment {
  id: ID!
  periodCode: String!
  year: String!
  semester: Int!
  isDisabled: Boolean!
  createdAt: String!
  updatedAt: String!
  createdBy: User
  updatedBy: User
}

*/
